export const getAll = {
    method: 'GET',
    paths: ['/api/locations'],
    fields: {
        filter: {
            type: 'keyString',
            required: true,
        },
        locationId: {
            type: 'mongoId',
        },
    },
};
//# sourceMappingURL=locations_get_all.js.map